import AGREGAR_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/agregarOficioAutorizacion.gql';
import REMOVER_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/removerOficioAutorizacion.gql';
import ACTUALIZAR_OFICIO_AUTORIZACION from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/actualizarOficioAutorizacion.gql';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  mixins: [mixSubirArchivo],
  methods: {
    // Guardar Oficio de Autorización
    async mixAgregarOficio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { oficio } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OFICIO_AUTORIZACION,
          variables: { oficio },
          // Refetch todos los queries activos de filtrarOficiosAutorizacion
          refetchQueries: ['filtrarOficiosAutorizacion'],
          awaitRefetchQueries: true,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarOficio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_OFICIO_AUTORIZACION,
          variables: {
            id: this.oficioAutorizacionEliminar.id,
          },
          refetchQueries: ['filtrarOficiosAutorizacion'],
          awaitRefetchQueries: true,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.borrarDocumento(this.oficioAutorizacionEliminar);
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEditarOficio() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { oficio } = this;
      const idOficio = this.oficioAutorizacionEditar.id;
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_OFICIO_AUTORIZACION,
          variables: { id: idOficio, oficio },
          refetchQueries: ['filtrarOficiosAutorizacion'],
          awaitRefetchQueries: true,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixGetPdf(publicKey) {
      return this.axios
        .get(`${BASE_URL}/${publicKey}`, {
          responseType: 'blob',
        })
        .then((res) => ({
          data: res.data,
        }))
        .catch((err) => {
          this.mixMensajeError(err.data.message);
          return {
            err: err.data.message,
          };
        });
    },
    borrarDocumento(oficio) {
      if (oficio.fileData === '' || oficio.fileData === null) return;
      const file = JSON.parse(oficio.fileData).public_key;
      this.axios.delete(`${this.$urlFileServer}/${file}`);
    },
  },
};
